import React from 'react';
import { BsShieldCheck, BsGraphUp, BsClipboardCheck, BsBinoculars } from 'react-icons/bs';
import { FaQuoteLeft } from 'react-icons/fa';
import './BuildStartSealOfApproval.css';

const BuildStartSealOfApproval = () => {
  return (
    <section className="bssa-section">
      <div className="bs-container">
        
        {/* Header */}
        <div className="bssa-header">
          <h2>
            The Build Start <span className="bs-text-gold-gradient">Seal of Approval</span>
          </h2>
          <p>
            Our 4-point Vetting Gauntlet ensures every professional meets the highest 
            standards of skill, reputation, and integrity.
          </p>
        </div>

        {/* 4-Step Process Cards */}
        <div className="bssa-grid">
          
          {/* Step 1 */}
          <div className="bssa-card">
            <div className="bssa-icon-box">
              <span className="bssa-number">1</span>
              <BsShieldCheck className="bssa-icon" />
            </div>
            <h3>License & Insurance Verification</h3>
            <p>We verify every license, certification, and insurance policy to ensure they are current and valid.</p>
          </div>

          {/* Step 2 */}
          <div className="bssa-card">
            <div className="bssa-icon-box">
              <span className="bssa-number">2</span>
              <BsGraphUp className="bssa-icon" />
            </div>
            <h3>Reputation & Review Analysis</h3>
            <p>Our team meticulously analyzes online reviews and requires a minimum 3-star average rating.</p>
          </div>

          {/* Step 3 */}
          <div className="bssa-card">
            <div className="bssa-icon-box">
              <span className="bssa-number">3</span>
              <BsClipboardCheck className="bssa-icon" />
            </div>
            <h3>Portfolio & Craftsmanship</h3>
            <p>We review past work for quality, attention to detail, and consistency, ensuring true mastery of their craft.</p>
          </div>

          {/* Step 4 */}
          <div className="bssa-card">
            <div className="bssa-icon-box">
              <span className="bssa-number">4</span>
              <BsBinoculars className="bssa-icon" />
            </div>
            <h3>Continuous Monitoring</h3>
            <p>Our work isn’t done. We continuously monitor performance and reviews to ensure standards are always met.</p>
          </div>

        </div>

        {/* Testimonial Block */}
        <div className="bssa-testimonial">
            <div className="bssa-quote-icon">
                <FaQuoteLeft />
            </div>
            <p className="bssa-quote-text">
                "BuildStart helped us find the right planning consultant in days. It saved weeks of delays and thousands in redesign costs."
            </p>
            <div className="bssa-quote-author">
                - A. Developer, <span className="bssa-location">Sydney</span>
            </div>
        </div>

      </div>
    </section>
  );
};

export default BuildStartSealOfApproval;